angular.module('userSettingsMod')

.controller('userPassCtrl', ['$location', '$scope', 'cnfg', '$templateCache', 'storage', '$timeout', function($location, $scope, cnfg, $templateCache, storage, $timeout) {

  $scope.pass_form = {};

  $scope.send = async function() {
    var data = angular.copy($scope.pass_form);
    if ($scope.passForm.$valid) {

      var dataToSend = {
				user_id: storage.getMainStorage().user.user_id,
        password: data.password,
        old_password: data.old_password
      };

			try {

				let user = await gudhub.updateUser(dataToSend);

				$scope.errMsg = 'Ok!';
				$scope.$digest();

			} catch(error) {

				$scope.errMsg = error.data + ' Please, try again...';

			} finally {

				$timeout(function() {
					$scope.errMsg = "";
				}, 1500);
			}
    }
  };

	$scope.cancel = function(){
		$location.path('/apps');
	};

}]);
